import '@fontsource/poppins';

import { Box, TextField, Typography } from '@mui/material';

import React, { useState } from 'react';

export default function ContactInformation({ profile, setProfile }) {
  const [firstChange, setFirstChange] = useState(true);

  const handlePhoneNumberChange = (ev) => {
    const {
      target: { name = 'phone_number', value, type: inputType },
    } = ev;

    let newValue = value;

    if (inputType === 'tel') {
      let cleanedInput = value.replace(/[^+\d]/g, (match, offset) => {
        return offset === 0 && match === '+' ? match : '';
      });

      if (!cleanedInput.startsWith('+')) {
        cleanedInput = `+${cleanedInput}`;
      }

      if (firstChange && cleanedInput.length === 2 && cleanedInput[1] !== '6') {
        cleanedInput = cleanedInput.replace('+', '');
        cleanedInput = `+65${cleanedInput}`;
        setFirstChange(false);
      }

      newValue = cleanedInput;
    }

    setProfile((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };
  return (
    <>
      <div className='font-poppins py-4 pl-4 text-lg font-bold'>
        Contact Information
      </div>

      <Box
        sx={{
          display: 'flex',

          width: '100%',
        }}
      >
        <Box flex={1} ml={2}>
          <Typography fontFamily='Poppins'>Email</Typography>
          <TextField
            fullWidth
            size='medium'
            variant='outlined'
            placeholder='e.g. john@company.com'
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
              },
              mt: 1,
            }}
            value={profile?.email}
            onChange={(e) => setProfile({ ...profile, email: e.target.value })}
          />
          <br />
          <br />
        </Box>

        <Box flex={1} mr={2} ml={2}>
          <Typography fontFamily='Poppins'>Mobile No.</Typography>
          <Box mt={0.6}>
            <TextField
              fullWidth
              name='phone_number'
              size='medium'
              variant='outlined'
              type='tel'
              placeholder='e.g. +65'
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                },
                mt: 0.3,
              }}
              value={profile?.phone_number || ''}
              onChange={handlePhoneNumberChange}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
